import React from "react";
import { colors } from "../../styling.constants";

export const Star = () => <span style={{ color: colors.primaryRed }}>* </span>;
